interface GMVPerformanceCardProps {
  className?: string;
}

export function GMVPerformanceCard({ className }: GMVPerformanceCardProps) {
  return (
    <div
      className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-start w-[280px] h-[200px] lg:w-[322px] lg:h-[240px] p-4 lg:p-5 ${className || ''}`}
      style={{
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
        borderRadius: '20px',
        border: '1px solid rgba(59, 130, 246, 0.35)',
        background:
          'linear-gradient(158deg, rgba(20, 40, 80, 0.95) 0%, rgba(15, 32, 65, 0.92) 40%, rgba(10, 25, 55, 0.95) 100%)',
        boxShadow:
          '0 0 80px 0 rgba(59, 130, 246, 0.15), 0 0 160px 0 rgba(59, 130, 246, 0.05), 0 24px 60px 0 rgba(0, 0, 0, 0.50), 0 1px 0 1px rgba(255, 255, 255, 0.08) inset, 0 0 40px 1px rgba(59, 130, 246, 0.03) inset',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div className="flex gap-1 mb-2">
        <div
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '4px',
            background: '#3B82F6',
            boxShadow: '0 0 8px 0 rgba(59, 130, 246, 0.60)',
          }}
        ></div>
        <div
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '4px',
            background: '#3B82F6',
            boxShadow: '0 0 8px 0 rgba(59, 130, 246, 0.60)',
          }}
        ></div>
        <div
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '4px',
            background: '#3B82F6',
            boxShadow: '0 0 8px 0 rgba(59, 130, 246, 0.60)',
          }}
        ></div>
      </div>

      <div
        style={{
          color: 'rgba(255, 255, 255, 0.40)',
          fontFamily: 'Inter',
          fontSize: '9px',
          fontWeight: '700',
          letterSpacing: '1.5px',
          textTransform: 'uppercase',
        }}
      >
        TOPLAM GMV
      </div>

      <div className="flex items-center justify-between w-full">
        <div
          style={{
            color: 'rgba(255, 255, 255, 0.40)',
            fontFamily: 'Inter',
            fontSize: '9px',
            fontWeight: '700',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
          }}
        >
          AKTIF SATICI
        </div>
        <div
          style={{
            color: '#4ADE80',
            textShadow: '0 0 20px rgba(74, 222, 128, 0.40)',
            fontFamily: 'Inter',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: '800',
            lineHeight: 'normal',
            marginTop: '-14px',
          }}
        >
          +128
        </div>
      </div>

      <div
        style={{
          position: 'absolute',
          left: '1px',
          bottom: '65px',
          display: 'flex',
          height: '80px',
          width: '100%',
          padding: '0 24px',
          justifyContent: 'center',
          alignItems: 'flex-end',
          gap: '6px',
          flexShrink: 0,
        }}
      >
        {[...Array(10)].map((_, i) => {
          const heights = [
            '28px',
            '32px',
            '24px',
            '36px',
            '30px',
            '40px',
            '44px',
            '52px',
            '64px',
            '68px',
          ];
          const isHighlighted = i >= 7;
          return (
            <div
              key={i}
              style={{
                height: heights[i],
                minWidth: '20px',
                flex: '1 0 0',
                borderRadius: '2px',
                background: isHighlighted
                  ? 'linear-gradient(180deg, #3B82F6 0%, #2563EB 100%)'
                  : 'linear-gradient(180deg, rgba(59, 130, 246, 0.35) 0%, rgba(37, 99, 235, 0.20) 100%)',
                filter: isHighlighted
                  ? 'drop-shadow(0 0 16px rgba(59, 130, 246, 0.35))'
                  : 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.10))',
              }}
            />
          );
        })}
      </div>

      <div
        style={{
          display: 'flex',
          width: '320px',
          padding: '14px 24px',
          alignItems: 'center',
          gap: '140.37px',
          position: 'absolute',
          left: '1px',
          bottom: '1px',
          borderTop: '1px solid rgba(59, 130, 246, 0.15)',
          background: 'rgba(0, 0, 0, 0.20)',
        }}
      >
        <div
          style={{
            color: 'rgba(255, 255, 255, 0.40)',
            fontFamily: 'Inter',
            fontSize: '9px',
            fontWeight: '700',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
          }}
        >
          Performansı
        </div>
      </div>
    </div>
  );
}
